import appChargeLogo from '@/assets/icons/common/appcharge.svg';
import { useTranslate } from '@/hooks/useTranslate';

export const PoweredByAppcharge = () => {
  const { t } = useTranslate();

  return (
    <div className="flex items-center justify-center gap-2">
      <div className="text-xs text-base-black">{t('poweredBy')}</div>
      <img src={appChargeLogo} alt="appcharge" className="w-30 h-11" />
    </div>
  );
};
